"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPolygon = void 0;
const configs_1 = require("@teleportdao/configs");
const teleport_tokens_1 = require("./teleport-tokens");
const ethereum = configs_1.tokens.ethereum.mainnet;
const polygon = configs_1.tokens.polygon.mainnet;
const arbitrum = configs_1.tokens.arbitrum.mainnet;
const optimism = configs_1.tokens.optimism.mainnet;
const base = configs_1.tokens.base.mainnet;
exports.toPolygon = {
    ethereum: {
        [ethereum.USDTAddress]: polygon.USDTAddress,
        [ethereum.USDCAddress]: polygon.USDCAddress,
        [ethereum.WETHAddress]: polygon.WETHAddress,
        [ethereum.WMATICAddress]: polygon.WMATICAddress,
        [ethereum.WBTCAddress]: polygon.WBTCAddress,
        [teleport_tokens_1.ethTeleswapToken]: polygon.WETHAddress,
    },
    arbitrum: {
        [arbitrum.USDTAddress]: polygon.USDTAddress,
        [arbitrum.USDCAddress]: polygon.USDCAddress,
        [arbitrum.WETHAddress]: polygon.WETHAddress,
        [arbitrum.WMATICAddress]: polygon.WMATICAddress,
        [arbitrum.WBTCAddress]: polygon.WBTCAddress,
        [teleport_tokens_1.ethTeleswapToken]: polygon.WETHAddress,
    },
    optimism: {
        [optimism.USDTAddress]: polygon.USDTAddress,
        [optimism.USDCAddress]: polygon.USDCAddress,
        [optimism.WETHAddress]: polygon.WETHAddress,
        [optimism.WBTCAddress]: polygon.WBTCAddress,
        [teleport_tokens_1.ethTeleswapToken]: polygon.WETHAddress,
    },
    base: {
        [base.USDCAddress]: polygon.USDCAddress,
        [base.WETHAddress]: polygon.WETHAddress,
        [teleport_tokens_1.ethTeleswapToken]: polygon.WETHAddress,
    },
};
//# sourceMappingURL=cross-chain-tokens.js.map